import { render, staticRenderFns } from "./languageComponent.vue?vue&type=template&id=5bd4b17b&"
import script from "./languageComponent.vue?vue&type=script&lang=ts&"
export * from "./languageComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports